module.exports = __webpack_public_path__ + "static/media/20161181253743-46.16ebc306.jpg";